import React from 'react';
import styles from './bdroLoginForm.module.css';
export var BdroLoginForm = function (_a) {
    var _b = _a.isPending, isPending = _b === void 0 ? false : _b, onSubmit = _a.onSubmit, _c = _a.errorNode, errorNode = _c === void 0 ? null : _c;
    var _d = React.useState(''), login = _d[0], setLogin = _d[1];
    var _e = React.useState(''), password = _e[0], setPassword = _e[1];
    var handleSubmit = React.useCallback(function (e) {
        e.preventDefault();
        var data = { login: login, password: password };
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(data);
    }, [login, password, onSubmit]);
    return (React.createElement("form", { className: styles.BdroLoginForm, onSubmit: handleSubmit },
        React.createElement("input", { name: "login", type: "text", className: styles.BdroLoginFormInput, placeholder: "Login", value: login, onChange: function (e) { return setLogin(e.target.value); }, required: true }),
        React.createElement("input", { name: "password", type: "password", className: styles.BdroLoginFormInput, placeholder: "Password", value: password, onChange: function (e) { return setPassword(e.target.value); }, required: true }),
        errorNode,
        React.createElement("button", { type: "submit", className: styles.BdroLoginFormButton, disabled: isPending }, isPending ? 'Loading...' : 'Submit')));
};
